<template>
  <div class="header">
    <WButton
      :aria-label="leftCTALabel"
      :icon="leftCTAIcon"
      variant="tertiary"
      class="header__cta-secondary"
      icon-button
      @click="$emit('onLeftCTAClick')"
    />
    <WButton
      class="header__cta-primary"
      :disabled="primaryCTADisabled"
      :loading="primaryCTALoading"
      :icon="primaryCTAIcon"
      :variant="primaryCTAContextual"
      block
      @click="$emit('onPrimaryCTAClick')"
    >
      {{ primaryCTALabel }}
    </WButton>
    <WButton
      v-if="rightCTAVisible"
      class="header__cta-secondary"
      variant="tertiary"
      :aria-label="rightCTALabel"
      :disabled="rightCTADisabled"
      :icon="rightCTAIcon"
      :data-testId="rightCTATestId"
      icon-button
      @click="$emit('onRightCTAClick')"
    />
  </div>
</template>

<script>
import { WButton } from '@alice-health/wonderland-vue'

export default {
  name: 'HDetailsHeader',
  components: { WButton },
  props: {
    leftCTAIcon: {
      type: String,
      default: 'icArrowLeft'
    },
    leftCTALabel: {
      type: String,
      default: 'Retornar'
    },
    primaryCTAIcon: { type: String, default: undefined },
    primaryCTALabel: { type: String, default: undefined },
    primaryCTAContextual: {
      type: String,
      default: 'primary'
    },
    primaryCTADisabled: Boolean,
    primaryCTALoading: Boolean,
    rightCTAVisible: {
      type: Boolean,
      default: false
    },
    rightCTATestId: { type: String, default: undefined },
    rightCTALabel: { type: String, default: undefined },
    rightCTAIcon: { type: String, default: undefined },
    rightCTADisabled: Boolean
  },
  emits: ['onLeftCTAClick', 'onPrimaryCTAClick', 'onRightCTAClick']
}
</script>

<style lang="scss" scoped>
.header {
  align-items: center;
  background: var(--sys-color-surface-background-light);
  border-bottom: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-20);
  display: flex;
  gap: var(--gl-spacing-04);
  justify-content: space-between;
  padding: var(--gl-spacing-03) var(--gl-spacing-06);
  position: sticky;
  top: 0;
  z-index: 1;

  &__cta-primary {
    width: 100%;
  }
}
</style>
